import React from 'react'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import Layout from '../../components/layout'
import Header from '../../components/header'
import Footer from '../../components/footer'
import '../../components/career.scss'

const ExploreIndex = ({ data }) => (
  <Layout>
    <Header />
    <section className='career all'>
      <h1>Explore our career paths</h1>
      {data.allCareersJson.edges.map(({ node }) => (
        <div className="primary-content" key={node.name}>
          <div className="career-path">
            {node.name === 'Analytics' && (
              <>
                <Img
                  fluid={data.imageAnalyticsMobile.childImageSharp.fluid}
                  className="career-path-image hide-for-desktop"
                />
                <Img
                  fluid={data.imageAnalytics.childImageSharp.fluid}
                  className="career-path-image hide-for-mobile"
                />
              </>
            )}
            {node.name === 'Consulting' && (
              <>
                <Img
                  fluid={data.imageConsultingMobile.childImageSharp.fluid}
                  className="career-path-image hide-for-desktop"
                />
                <Img
                  fluid={data.imageConsulting.childImageSharp.fluid}
                  className="career-path-image hide-for-mobile"
                />
              </>
            )}
            {node.name === 'Design' && (
              <>
                <Img
                  fluid={data.imageDesignMobile.childImageSharp.fluid}
                  className="career-path-image hide-for-desktop"
                />
                <Img
                  fluid={data.imageDesign.childImageSharp.fluid}
                  className="career-path-image hide-for-mobile"
                />
              </>
            )}
            {node.name === 'Digital' && (
              <>
                <Img
                  fluid={data.imageDigitalMobile.childImageSharp.fluid}
                  className="career-path-image hide-for-desktop"
                />
                <Img
                  fluid={data.imageDigital.childImageSharp.fluid}
                  className="career-path-image hide-for-mobile"
                />
              </>
            )}
            {node.name === 'Implementation' && (
              <>
                <Img
                  fluid={data.imageImplementationMobile.childImageSharp.fluid}
                  className="career-path-image hide-for-desktop"
                />
                <Img
                  fluid={data.imageImplementation.childImageSharp.fluid}
                  className="career-path-image hide-for-mobile"
                />
              </>
            )}
            {node.name === 'Research' && (
              <>
                <Img
                  fluid={data.imageResearchMobile.childImageSharp.fluid}
                  className="career-path-image hide-for-desktop"
                />
                <Img
                  fluid={data.imageResearch.childImageSharp.fluid}
                  className="career-path-image hide-for-mobile"
                />
              </>
            )}
            <div className="career-path-content">
              <h2>{node.name}</h2>
              <p className="summary">{node.summary}</p>
              <a href={'/spContent/CareersQuiz/explore/' + node.name.toLowerCase() + '/index.html'}
                className="btn btn-primary btn-fill explore-cta"
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      ))}
      <Footer />
    </section>
  </Layout>
)

export const query = graphql`
  {
    allCareersJson(sort: {
      fields: name
    }) {
      edges {
        node {
          name
          summary
        }
      }
    }
    imageAnalytics: file(relativePath: { eq: "explore/analytics-hero.jpg" }) {
      ...image
    }
    imageAnalyticsMobile: file(relativePath: { eq: "explore/mobile/analytics-hero.jpg" }) {
      ...imageMobile
    }
    imageConsulting: file(relativePath: { eq: "explore/consulting-hero.jpg" }) {
      ...image
    }
    imageConsultingMobile: file(relativePath: { eq: "explore/mobile/consulting-hero.jpg" }) {
      ...imageMobile
    }
    imageDesign: file(relativePath: { eq: "explore/design-hero.jpg" }) {
      ...image
    }
    imageDesignMobile: file(relativePath: { eq: "explore/mobile/design-hero.jpg" }) {
      ...imageMobile
    }
    imageDigital: file(relativePath: { eq: "explore/digital-hero.jpg" }) {
      ...image
    }
    imageDigitalMobile: file(relativePath: { eq: "explore/mobile/digital-hero.jpg" }) {
      ...imageMobile
    }
    imageImplementation: file(relativePath: { eq: "explore/implementation-hero.jpg" }) {
      ...image
    }
    imageImplementationMobile: file(relativePath: { eq: "explore/mobile/implementation-hero.jpg" }) {
      ...imageMobile
    }
    imageResearch: file(relativePath: { eq: "explore/research-hero.jpg" }) {
      ...image
    }
    imageResearchMobile: file(relativePath: { eq: "explore/mobile/research-hero.jpg" }) {
      ...imageMobile
    }
  }
`

export default ExploreIndex
